
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { FiEye, FiEyeOff } from "react-icons/fi";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import LoginService from "../../Services/login_service";
import Footer from "../Footer/Footer";
import Varanouslabslogo from "../../assets/Varanouslabslogo.png";

import "./Login.css";

function Login() {
  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    setEmail("");
    setPassword("");
  }, []);

  const togglePasswordVisibility = () => {
    setShowPassword((prev) => !prev);
  };

  const validateForm = () => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!email.trim()) {
      toast.warning("Email is required.");
      return false;
    }
    if (!emailRegex.test(email)) {
      toast.warning("Please enter a valid email address.");
      return false;
    }
    if (!password.trim()) {
      toast.warning("Password is required.");
      return false;
    }
    if (password.length < 6) {
      toast.warning("Password must be at least 6 characters.");
      return false;
    }
    return true;
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    setIsSubmitting(true);
    try {
      const result = await LoginService.login(email, password);
      if (result?.success) {
        const userResult = await LoginService.getUserDetails();

        if (userResult?.success) {
          toast.success("Successfully logged in!");
          setEmail("");
          setPassword("");
          setTimeout(() => {
            navigate("/customerPortal/MyDashboard");
          }, 500);
        } else {
          toast.error(userResult?.message || "Failed to load user data.");
        }
      } else {
        toast.error(
          result?.message === "User not found"
            ? "Incorrect email or password."
            : result?.message || "Login failed."
        );
      }
    } catch (error) {
      console.error("Login error:", error);
      toast.error("An error occurred during login. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <div className="auth-container reverse-layout">
        {/* Info Panel */}
        <div className="auth-info-panel my-text-style">
          <div className="logo-section">
            <img src={Varanouslabslogo} alt="Varanous Labs Logo" className="login-logo" />
          </div>
          <h2>Welcome to Varanous Labs</h2>
          <p>
            Login with your credentials to access all Products and Quotation.
          </p>
        </div>

        {/* Login Form Panel */}
        <div className="auth-form-panel my-text-style">
          <h2>Sign In</h2>
          <p className="subtext">Access your account</p>

          <form onSubmit={handleLogin} noValidate>
            <input
              type="email"
              placeholder="Email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              autoComplete="off"
            />

            <div className="password-field">
              <input
                type={showPassword ? "text" : "password"}
                placeholder="Password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                autoComplete="new-password"
              />
              <span onClick={togglePasswordVisibility} className="eye-icon">
                {showPassword ? <FiEyeOff /> : <FiEye />}
              </span>
            </div>

            <button type="submit" className="submit-btn" disabled={isSubmitting}>
              {isSubmitting ? "Signing In..." : "Sign In"}
            </button>

            <a href="/forgot-password" className="forgot-password-link">
              Forgot your password?
            </a>
          </form>
        </div>
      </div>

      <Footer />

      <ToastContainer
        position="bottom-left"
        autoClose={4000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        pauseOnHover
        draggable
        theme="colored"
        style={{ zIndex: 9999 }}
      />
    </>
  );
}

export default Login;
